import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiComponentsModule } from '@mwe/ui/components';
import { UiCommonsModule } from '@mwe/ui/commons';
import { EnvironmentService, ProfileService } from '@mwe/services';
import { TranslateService } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';
import { version } from './environments/version';
import { KeycloakRefreshService } from '@shared-ikp/service/keycloak-refresh.service';
import { KeycloakEventLoggerService } from '@shared-ikp/service/keycloakEventLogger.service';
import { BeraterEnvironmentService } from './service/environment/berater-environment.service';

@Component({
  standalone: true,
  imports: [RouterModule, UiComponentsModule, UiCommonsModule],
  selector: 'ikp-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [ProfileService, EnvironmentService, Meta],
})
export class AppComponent {
  public translate = inject(TranslateService);
  private readonly metaService = inject(Meta);
  private readonly keycloakRefreshService: KeycloakRefreshService;
  private readonly keycloakEventLoggerService: KeycloakEventLoggerService;
  private readonly envService = inject(BeraterEnvironmentService);

  constructor() {
    this.translate.setDefaultLang('de');
    this.translate.addLangs(['de', 'en']);
    this.translate.use('de');
    this.metaService.addTag(
      {
        name: 'version',
        content: version,
      },
      true,
    );
    this.keycloakRefreshService = inject(KeycloakRefreshService);
    if (!this.envService.isProduction) {
      this.keycloakEventLoggerService = inject(KeycloakEventLoggerService);
    }
  }
}
